module.exports = __webpack_public_path__ + "img/login_bg@2x.922fbc73.png";